import { render } from "./IngenieriaView.vue?vue&type=template&id=d872df00"
import script from "./IngenieriaView.vue?vue&type=script&lang=js"
export * from "./IngenieriaView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__